
import React from 'react';
import styled from '@emotion/styled';

interface SimpleCardProps {
 icon: string;
 text: string;
 cardBg?: string; 
 iconShadow?: boolean; 
 textSize?: string | number; 
 iconSize?: string | number; 
}

const SimpleCard: React.FC<SimpleCardProps> = ({
 icon,
 text,
 cardBg,
 iconShadow = true,
  textSize,
 iconSize,
}) => {
 return (
  <Card cardBg={cardBg}>
   <IconBox iconShadow={iconShadow}>
    <Icon src={icon} alt="Card Icon" iconSize={iconSize} />
   </IconBox>
   <Description textSize={textSize}>{text}</Description>
  </Card>
 );
};

export default SimpleCard;

const Card = styled.div<{ cardBg?: string }>`
 background-color: ${({ cardBg }) => cardBg ?? '#FEF5F700'};
 border-radius: 24px;
 padding: 48px 28px;
 display: flex;
 flex-direction: column;
 align-items: center;
 text-align: center;
 gap: 24px;
 border: 1px solid ${({ theme }: any) => theme.palette.borderColor};
 transition: transform 0.2s ease;

 &:hover {
  transform: translateY(-4px);
 }

 @media (max-width: 480px) {
  width: 100%;
 }
`;

const IconBox = styled.div<{ iconShadow?: boolean }>`
 background-color: #ffffff;
 border-radius: 16px;
 padding: 20px;
 display: flex;
 justify-content: center;
 align-items: center;
 box-shadow: ${({ iconShadow }) =>
  iconShadow ?? true ? '0px 4px 14px 0px #00000026' : 'none'};
`;

const Icon = styled.img<{ iconSize?: string | number }>`
 width: ${({ iconSize }) =>
  typeof iconSize === 'number' ? `${iconSize}px` : iconSize ?? '40px'};
 height: ${({ iconSize }) =>
  typeof iconSize === 'number' ? `${iconSize}px` : iconSize ?? '40px'};
 object-fit: contain;
`;

const Description = styled.p<{ textSize?: string | number }>`
 font-size: ${({ textSize }) =>
  typeof textSize === 'number' ? `${textSize}px` : textSize ?? '14px'};
 font-weight: 500;
 color: #000000cc;
 line-height: 1.6;
 max-width: 400px;

 @media (max-width: 768px) {
  font-size: ${({ textSize }) =>
   typeof textSize === 'number' ? `${textSize}px` : textSize ?? '14px'};
 }
`;
